import * as React from 'react';
import * as styled from './styled';
import GroupContext from './GroupContext';
import {GroupObject, GroupProps, GroupVariant} from './types';
import Dropdown from 'components/Dropdown';
import {IconChevronBottom} from 'icons';

/**
 * The group of the filter.
 * @param {GroupProps} props
 * @return {React.ReactElement<GroupProps>}
 * @constructor
 */
function Group(
    props: GroupProps,
): React.ReactElement<GroupProps> {
  const group: GroupObject = {
    name: props.name,
    label: props.label,
    variant: props.variant,
  };

  /**
   * Get dropdown trigger.
   * @param {void} open
   * @param {void} close
   * @return {JSX.Element}
   */
  function getTrigger(
      open: () => void,
      close: () => void,
  ): JSX.Element {
    return (
      <styled.Trigger type="button" onClick={() => open()}>
        {props.label}
        <styled.Icon>
          <IconChevronBottom />
        </styled.Icon>
      </styled.Trigger>
    );
  }

  /**
   * render content
   * @param {any} group
   * @return {JSX.Element}
   */
  function renderContent(
      group: GroupObject,
  ): JSX.Element {
    switch (props.variant) {
      case GroupVariant.Inline: return (
        props.children(group) as JSX.Element
      );
      default: return (
        <Dropdown trigger={getTrigger} gap={4}>
          <styled.Wrapper>
            <styled.Title>
              {props.label}
            </styled.Title>
            <styled.Content>
              {props.children(group)}
            </styled.Content>
          </styled.Wrapper>
        </Dropdown>
      );
    }
  }

  return (
    <GroupContext.Provider value={group}>
      {renderContent(group)}
    </GroupContext.Provider>
  );
}

Group.defaultProps = {
  variant: GroupVariant.Default,
};

export default Group;
